// extracted by mini-css-extract-plugin
module.exports = {"column-value":"team-info_column-value__3p97M","row":"team-info_row__pnhac","pref":"team-info_pref__XDwc3"};